import { render, staticRenderFns } from "./StocScrap.vue?vue&type=template&id=5d652a06&scoped=true"
import script from "./StocScrap.vue?vue&type=script&lang=js"
export * from "./StocScrap.vue?vue&type=script&lang=js"
import style0 from "./StocScrap.vue?vue&type=style&index=0&id=5d652a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d652a06",
  null
  
)

export default component.exports